import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { Component, ElementRef, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CatalagosConfig } from 'src/app/models/CatalogosConfig';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { DialogCatAC } from 'src/app/shared/cat-autocomplete/catautocompleteAdd.component';
import { EnumFiltroFechas } from 'src/app/enums/FiltroFechas.enum';
import { AppOAuthStore } from 'src/app/models/AppOAuthSotarge';
import { httpConnect } from 'src/app/services/httpConnect.service';
import { DateAdapter } from '@angular/material/core';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { NotificationService } from 'src/app/services/Notification.service';
import { TipoToasta } from 'src/app/enums/Toasta.enum';
import { FieldValidator } from 'src/app/models/FieldValidator';
import { ToastaConfig, ToastaService } from 'ngx-toasta';
import { DialogConfirmacion } from 'src/app/shared/dialogs/confirmacion/dialogConfirmacion.component';
import { UtilsService } from 'src/app/services/Utils.service';
import { faCar, faComment, faPlus, faPlusCircle, faUnderline, faDownload } from '@fortawesome/free-solid-svg-icons';

// 2021-09-07 (aaangeles) CREACION
@Component({
  selector: 'app-dialogAddComponenteOrdenTaller',
  templateUrl: './../../Views/Dialogs/dialogAddComponenteOrdenTaller.component.html',
  styleUrls: [ './../../Styles/ordenDeTaller.component.scss','./../../../../../theme/styles/_common.scss'],
  encapsulation: ViewEncapsulation.None
})
export class dialogAddComponenteOrdenTaller implements OnInit {
  public displayToasta: boolean = true;
  public connectSvc: httpConnect;
  public catConfig: CatalagosConfig = new CatalagosConfig();
  public permisoPantalla: any;
  private requiredFields: Array<FieldValidator>;
  public configuraciones: ToastaConfig;
  public opciones: ToastaService;
  public icons: any = {
    addCircle: faPlusCircle,
    add: faPlus,
    comment: faComment,
    car: faCar,
    download: faDownload
  };

  completeDate = new Date();
  localCompleteDate = this.completeDate.toISOString();

  //Region de variables.
  public fallasUnidad: any = [];
  public dataFU: any;


  constructor(
    public dialogRef: MatDialogRef<dialogAddComponenteOrdenTaller>,
    public myStorage: AppOAuthStore,
    private httpConn: httpConnect,
    private fb: FormBuilder,
    private toastaConfig: ToastaConfig,
    private Notificacion: NotificationService,
    public dialog: MatDialog,
    private toastaService: ToastaService,
    private dateAdapter: DateAdapter<Date>,
    public utilsSrv: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    //this.idCarga = data.boton_editar || 0;
    this.connectSvc = this.httpConn;
    this.dateAdapter.setLocale('es-MX');
    this.configuraciones = this.toastaConfig;
    this.opciones = this.toastaService;
    this.Notificacion = new NotificationService(this.opciones, this.configuraciones);
    console.log(this.data);
    this.dataFU = this.data.fallasUnidad;
  }

  ngOnInit() {

  }

  ngAfterViewInit() {
  }

  public onOkClick() {
    this.fallasUnidad = [...this.dataFU];
    this.dialogRef.close(this.fallasUnidad);
  }

  OnCancelarClick() {
    this.dialogRef.close();
  }

  public ChangeValidar(ev, row) {
    if (ev.checked) {
        row.atendido = true;
      }
      else {
        row.atendido = false;
      }
    }

  public VerImagen(ev, row) {
    if (row.imagen != '') {
      window.open(row.imgPath, '_blank');
    }
  }
}
